module.exports = "https://beta.voredev.ru/assets/index/message-blasting-green-af125e66a6e208ae44243c330f819cc1.svg";